import axios from "axios";

const deleteItem = (url, idx) => {
  axios
    .post("http://doorangicamping.com:8080/admin" + url, { idx: idx })
    .then((data) => window.location.reload());
};
export default deleteItem;
